var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ny-main',{attrs:{"title":"Infinities 代理商平台","platform":"agency","route-data":_vm.routeData}})}
var staticRenderFns = []

export { render, staticRenderFns }